import axiosClient from "./axiosClient";

const url = "/registrations";

export const registrationApi = {
  // Get registrations for an event (admin)
  getByEvent(eventId, params) {
    return axiosClient.get(`${url}/${eventId}/registrations`, { params });
  },

  // Check-in manual (admin)
  checkInManual(registrationId) {
    return axiosClient.post(`${url}/checkin/manual/${registrationId}`);
  },

  // Check-in by QR (public)
  checkInQR(qrCode) {
    return axiosClient.post(`${url}/checkin/qr`, { qrCode });
  },

  // Check-out by QR
  checkOutQR(qrCode) {
    return axiosClient.post(`${url}/checkout/qr`, { qrCode });
  },

  // Check in info
  getCheckInInfo(qrCode, eventId) {
    return axiosClient.get(`${url}/checkin/qr/${qrCode}/${eventId}`);
  },

  // User registrations
  getUserRegistrations(params) {
    return axiosClient.get(`${url}/user`, { params });
  },

  // Register for event
  register(eventId) {
    return axiosClient.post(`${url}/${eventId}/register`);
  },

  // Cancel registration
  cancel(eventId) {
    return axiosClient.delete(`${url}/${eventId}/register`);
  },

  // Update registration status (admin)
  updateStatus(id, data) {
    return axiosClient.put(`${url}/${id}/status`, data);
  },

  remove(id) {
    return axiosClient.delete(`${url}/${id}`);
  },
  updateRegistrationCode(id, data) {
    return axiosClient.put(`${url}/${id}/registration-code`, data);
  },
  updateIsTakingRefuge(id, isTakingRefuge) {
    return axiosClient.put(`${url}/${id}/is-taking-refuge`, { isTakingRefuge });
  },
  adminAddUserToEvent(eventId, data) {
    return axiosClient.post(`${url}/${eventId}/admin/register-user`, data);
  },
};
